import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import axios, {AxiosError} from 'axios';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../utils/queryKeys';
import {type TypedTranslation} from '../../i18n';
import {startPresUpdateSpinnerAction, stopPresUpdateSpinnerAction} from '../../store/actions/spinner';
import {importPptPresentation} from '../presentation';

export const IMPORT_PPT_PRESENTATION_KEY = ['importPptPresentation'];

function useImportPptPresentation(): UseMutationResult<string, unknown, {file: File}, void> {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const {t} = useTranslation();

    return useMutation((args: {file: File}) => importPptPresentation(args.file), {
        mutationKey: IMPORT_PPT_PRESENTATION_KEY,
        onMutate: () => {
            dispatch(startPresUpdateSpinnerAction());
        },
        onSettled: () => {
            dispatch(stopPresUpdateSpinnerAction());
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
        },
        onError: (error) => {
            if (axios.isAxiosError(error)) {
                const errorData = (error as AxiosError<string>).response?.data;

                if (errorData) {
                    toast.error(t(errorData as TypedTranslation));
                }
            }
        },
    });
}

export default useImportPptPresentation;
